import type { StateCreator } from 'zustand';

export type ActivityCategory =
  | 'login'
  | 'param_change'
  | 'manual_intervention'
  | 'automation'
  | 'data_backup'
  | 'alert';

export type ActivityStatus = 'success' | 'warning' | 'critical' | 'system' | 'auto';

export interface ActivityLogEntry {
  id: string;
  timestamp: string;     // ISO
  category: ActivityCategory;
  action: string;        // kısa başlık
  detail: string;        // açıklama
  status: ActivityStatus;
  actor?: string;        // kullanıcı adı / 'system'
}

export interface ActivitySlice {
  activityLog: ActivityLogEntry[];
  addActivityLog: (entry: Omit<ActivityLogEntry, 'id'>) => void;
  clearActivityLog: () => void;
}

const MAX_ENTRIES = 500;

export const createActivitySlice: StateCreator<ActivitySlice> = (set, _get) => ({
  activityLog: [],

  addActivityLog: (entry) => {
    const next: ActivityLogEntry = { ...entry, id: `act-${Date.now()}-${Math.random().toString(36).slice(2, 7)}` };
    set(s => ({ activityLog: [next, ...s.activityLog].slice(0, MAX_ENTRIES) }));
  },

  clearActivityLog: () => set({ activityLog: [] }),
});
